import _ from 'lodash'
import invariant from 'tiny-invariant'

import { actionTypes } from '../actioncreators/actioncreators'

export const RulesReducer = (currentState = [], action) => {
  switch (action.type) {
    case actionTypes.ADD_RULE: {
      let nextState = _.cloneDeep(currentState)
      nextState[action.rowIndex].push(
        {
          id: action.id,
          text: '',
          examples: []
        }
      )

      ensureSingleEmptyFinalRow(nextState)
      return nextState
    }

    case actionTypes.CHANGE_RULE: {
      const [rowIndex, ruleIndex] = getRuleIndex(action.id, currentState)

      let nextState = cloneRuleArrays(currentState)
      shallowCloneRuleInRules(nextState, rowIndex, ruleIndex)
      nextState[rowIndex][ruleIndex].text = action.value
      return nextState
    }

    case actionTypes.DELETE_RULE: {
      let nextState = _.cloneDeep(currentState);
      const [rowIndex, ruleIndex] = getRuleIndex(action.id, nextState)
      nextState[rowIndex].splice(ruleIndex, 1)

      ensureSingleEmptyFinalRow(nextState)
      return nextState
    }

    case actionTypes.LOAD_EXAMPLE_MAP: {
      let nextState = _.cloneDeep(action.data.rules)
      return nextState
    }

    case actionTypes.SELECT_RULE: {
      let nextState = _.cloneDeep(currentState)
      const [rowIndex, ruleIndex] = getRuleIndex(action.id, nextState)
      nextState[rowIndex][ruleIndex].selected = true
      return nextState
    }

    case actionTypes.DESELECT_RULE: {
      let nextState = _.cloneDeep(currentState)
      const [rowIndex, ruleIndex] = getRuleIndex(action.id, nextState)
      nextState[rowIndex][ruleIndex].selected = false
      return nextState
    }

    case actionTypes.REORDER_RULE: {
      let nextState = _.cloneDeep(currentState)
      const rule = nextState[action.sourceRuleRowIndex][action.sourceRuleIndex]

      nextState[action.sourceRuleRowIndex].splice(
        action.sourceRuleIndex, 1)
      nextState[action.destinationRuleRowIndex].splice(
        action.destinationRuleIndex, 0, rule)

      ensureSingleEmptyFinalRow(nextState)
      return nextState
    }

    case actionTypes.ADD_EXAMPLE: {
      let nextState = _.cloneDeep(currentState)
      const [rowIndex, ruleIndex] = getRuleIndex(action.ruleId, nextState)
      nextState[rowIndex][ruleIndex].examples.push({
        id: action.id,
        text: ''
      })
      return nextState
    }

    case actionTypes.CHANGE_EXAMPLE: {
      const [rowIndex, ruleIndex, exampleIndex] = getExampleIndex(action.id, currentState)

      let nextState = cloneRuleArrays(currentState)
      shallowCloneRuleInRules(nextState, rowIndex, ruleIndex)

      let rule = nextState[rowIndex][ruleIndex]
      rule.examples = [...rule.examples]

      let example = rule.examples[exampleIndex]
      rule.examples[exampleIndex] = { ...example, text: action.value }

      return nextState
    }

    case actionTypes.DELETE_EXAMPLE: {
      let nextState = _.cloneDeep(currentState)
      const [rowIndex, ruleIndex, exampleIndex] = getExampleIndex(action.id, nextState)
      nextState[rowIndex][ruleIndex].examples.splice(exampleIndex, 1)

      return nextState
    }

    default: {
      return currentState
    }
  }
}

const cloneRuleArrays = oldRules => {
  let newRules = []
  oldRules.forEach(oldRow => {
    let newRow = [...oldRow]
    newRules.push(newRow)
  })

  return newRules
}

const shallowCloneRuleInRules = (nextState, rowIndex, ruleIndex) => {
  nextState[rowIndex][ruleIndex] = { ...nextState[rowIndex][ruleIndex] }
}

const getRuleIndex = (ruleId, rules) => {
  for (var rowIndex = 0; rowIndex < rules.length; rowIndex++) {
    const row = rules[rowIndex]
    for (var ruleIndex = 0; ruleIndex < row.length; ruleIndex++) {
      const rule = row[ruleIndex]
      if (rule.id === ruleId) {
        return [rowIndex, ruleIndex]
      }
    }
  }

  invariant(false, 'cannot find rule')
}

const getExampleIndex = (exampleId, rules) => {
  for (var rowIndex = 0; rowIndex < rules.length; rowIndex++) {
    const row = rules[rowIndex]
    for (var ruleIndex = 0; ruleIndex < row.length; ruleIndex++) {
      const rule = row[ruleIndex]
      for (var exampleIndex = 0; exampleIndex < rule.examples.length; exampleIndex++) {
        const example = rule.examples[exampleIndex]

        if (example.id === exampleId) {
          return [rowIndex, ruleIndex, exampleIndex]
        }
      }
    }
  }

  invariant(false, 'cannot find example')
}

const lastRowIsEmpty = rules => {
  return (rules[rules.length - 1].length === 0)
}

const secondToLastRowIsEmpty = rules => {
  return (rules[rules.length - 2].length === 0)
}

const removeLastRow = rules => {
  rules.pop()
}

const ensureSingleEmptyFinalRow = rules => {
  const removeDuplicateTrailingEmptyRows = rules => {
    while (rules.length > 1 &&
      lastRowIsEmpty(rules) &&
      secondToLastRowIsEmpty(rules)) {
      removeLastRow(rules)
    }
  }

  const ensureEmptyFinalRow = rules => {
    if (rules[rules.length - 1].length !== 0) {
      rules.push([])
    }
  }

  removeDuplicateTrailingEmptyRows(rules)
  ensureEmptyFinalRow(rules)
}

export default RulesReducer
